import { Download, FileText } from "lucide-react";
import { toast } from "sonner";
import { btnDark, btnLine, useDownload } from "./shared";

export default function FilePanel({ caseId, forms, process }) {
  const { download, busy } = useDownload();
  const compile = async () => {
    const missing = await download(`/cases/${caseId}/file/pdf`, "visa-application-file.pdf", "file");
    if (missing && Number(missing) > 0) toast.message(`${missing} required item(s) are still missing — they are marked on divider pages.`);
  };
  return (
    <div data-testid="file-panel" className="max-w-3xl">
      <h3 className="font-serif text-xl text-heading">Your print-ready file</h3>
      <p className="mt-2 text-sm text-muted">One PDF in the order the mission asks for: cover, contents, a divider page for every item, your filled forms, CV, letters and every uploaded document, then a checklist of originals. Print two identical A4 sets, unstapled.</p>
      <button onClick={compile} disabled={busy === "file"} className={`${btnDark} mt-5`} data-testid="compile-file-btn"><Download size={15} /> {busy === "file" ? "Compiling…" : "Compile and download file"}</button>

      <h4 className="mt-10 text-sm font-semibold uppercase tracking-wider text-muted">Filled forms</h4>
      <ul className="mt-3 divide-y divide-navy/10 border-y border-navy/10">
        {forms.map((f) => (
          <li key={f.form_key} className="flex items-center justify-between gap-4 py-3">
            <span className="flex items-center gap-2 text-sm text-navy"><FileText size={15} /> {f.title}{f.copies && <span className="text-muted"> · {f.copies}</span>}</span>
            <button onClick={() => download(`/cases/${caseId}/forms/${f.form_key}/pdf`, `${f.form_key}.pdf`)} disabled={busy === `/cases/${caseId}/forms/${f.form_key}/pdf`} className={btnLine} data-testid={`form-pdf-${f.form_key}`}>
              <Download size={14} /> PDF
            </button>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-muted">The national visa form is the official fillable PDF from the German missions, completed with your answers. Check every field, then sign by hand after printing.</p>
      {process?.application_form && (
        <p className="mt-4 text-sm text-muted">Official application channel: <a className="text-tblue underline" href={process.application_form.url} target="_blank" rel="noreferrer">{process.application_form.name}</a></p>
      )}
    </div>
  );
}
